import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.SUPABASE_URL || 'https://ckhkaoudrwefuxcjxrcy.supabase.co';
const supabaseAnonKey = process.env.SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNraGthb3VkcndlZnV4Y2p4cmN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE3MzQ5ODMsImV4cCI6MjA1NzMxMDk4M30.HKvB2nZ2rICHbyJYd8CTj0XBRrvVW54HD7rzeNF53x0';

// Default Supabase client (respects RLS)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Admin Supabase client (bypasses RLS when needed - backend only)
// This should only be used in server-side code with proper authentication
export const createAdminClient = () => {
  const serviceRoleKey = process.env.SUPABASE_SERVICE_ROLE_KEY;
  
  if (!serviceRoleKey) {
    console.warn('⚠️  SUPABASE_SERVICE_ROLE_KEY not found. Admin operations may fail.');
    return supabase; // Fallback to regular client
  }
  
  return createClient(supabaseUrl, serviceRoleKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false
    }
  });
};